import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "readonly", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    type: "number",
    value: _ctx.champDisplay,
    readonly: _ctx.readonly,
    id: _ctx.id,
    class: "form-control input-print-keep-margin",
    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}